<div class="progressSpinner" *ngIf="showProgressSpinner">
    <p-progressSpinner></p-progressSpinner>
</div>
<div class="container-fluid overflow-hidden">
    <header>
        <nav class="navbar">
            <div class="navbar-content">
                <div class="background-container w-100">
                    <img src="assets/images/backgrounds/background_header_2.png" class="background-header" alt="monex">
                    <div class="user-info-container">
                        <div class="logo-container">
                            <img src="assets/images/icons/monex_login_icon.svg" class="logo-img" alt="monex-icon"><br>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>
    <div class="user-name mb-3 mt-3">
        {{ cveUsuario }}
    </div>
    <div class="page-content card p-3 h-100">
        <app-change-password [cveUser]="cveUsuario"
                             [isModal]="false"
                             [showCurrentPassword]="true"
                             (changePasswordEmit)="changePassword($event)"></app-change-password>
    </div>
</div>


<div class="change-password-modal w-100 ">
    <p-dialog
            [(visible)]="showModalResponseModal"
            [modal]="true"
            [style]="{ top: '60px'}"
            [showHeader]="false"
            position="top"
            [draggable]="false">
        <div style="width: 350px" class="p-3 pt-4">
            <a id="close-change-password-modal-icon" class="close-change-password-modal-icon"
               (click)="closeModalResponseModal()">
                <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
            </a>
            <div class="icon text-center">
                <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg"
                     *ngIf="!showError">
                    <path
                            d="M22.4997 0.333008C10.5397 0.333008 0.833008 10.0397 0.833008 21.9997C0.833008 33.9597 10.5397 43.6663 22.4997 43.6663C34.4597 43.6663 44.1663 33.9597 44.1663 21.9997C44.1663 10.0397 34.4597 0.333008 22.4997 0.333008ZM16.628 31.2947L8.84967 23.5163C8.00467 22.6713 8.00467 21.3063 8.84967 20.4613C9.69467 19.6163 11.0597 19.6163 11.9047 20.4613L18.1663 26.7013L33.073 11.7947C33.918 10.9497 35.283 10.9497 36.128 11.7947C36.973 12.6397 36.973 14.0047 36.128 14.8497L19.683 31.2947C18.8597 32.1397 17.473 32.1397 16.628 31.2947Z"
                            fill="#39A84A"/>
                </svg>

                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"
                     *ngIf="showError">
                    <path
                            d="M22.0002 0.333496C10.0185 0.333496 0.333496 10.0185 0.333496 22.0002C0.333496 33.9818 10.0185 43.6668 22.0002 43.6668C33.9818 43.6668 43.6668 33.9818 43.6668 22.0002C43.6668 10.0185 33.9818 0.333496 22.0002 0.333496ZM32.8335 29.7785L29.7785 32.8335L22.0002 25.0552L14.2218 32.8335L11.1668 29.7785L18.9452 22.0002L11.1668 14.2218L14.2218 11.1668L22.0002 18.9452L29.7785 11.1668L32.8335 14.2218L25.0552 22.0002L32.8335 29.7785Z"
                            fill="#D22419"/>
                </svg>
            </div>
            <div class="title text-center mt-3" *ngIf="!showError">
                {{ "temporaryPassword.changePasswordSuccessTitle" | translate }}
            </div>
            <div class="title text-center mt-2">
                {{getErrorMessage() | translate}}
            </div>
        </div>
    </p-dialog>
</div>



